import { Card, CardActionArea, CardContent, Typography } from '@mui/material';
import type { Theme } from '@mui/material/styles';
import React from 'react';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

import useStyles from '../style';

function MobileMenuButton({
  text,
  onClick = () => {},
  up = false,
  down = false,
  showEffect = false,
}: {
  text: string;
  onClick?: () => void;
  up?: boolean;
  down?: boolean;
  showEffect?: boolean;
}) {
  const classes = useStyles();
  const pt = up ? 1.5 : 2.5;
  const pb = up ? 2.5 : 1.5;
  const mt = 3;
  const mb = up ? 3 : 12;
  return (
    <Card
      sx={{
        mt: mt,
        mb: mb,
        borderRadius: 2,
        border: (t: Theme) => `1px solid ${t.palette.divider}`,
        overflow: 'hidden',
      }}
      className={showEffect ? classes.pulse : undefined}
    >
      <CardActionArea onClick={onClick} sx={{ borderRadius: 'inherit' }}>
        <CardContent sx={{ textAlign: 'center', px: 2, pt: pt, pb: pb }}>
          {up ? (
            <Typography color="text.secondary">
              <ExpandLessIcon />
            </Typography>
          ) : null}
          <Typography variant="body1" color="text.secondary">
            {text}
          </Typography>
          {down ? (
            <Typography color="text.secondary">
              <ExpandMoreIcon />
            </Typography>
          ) : null}
        </CardContent>
      </CardActionArea>
    </Card>
  );
}

export default MobileMenuButton;
